export const TWENTY_FOUR_HOURS_IN_MS = 24 * 60 * 60 * 1000;
